import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { BeneficiaryService } from '../Services/beneficiary.service';
import { NgModule } from '@angular/core';
import { HttpEventType, HttpClient } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { CMSService } from '../Services/cms.service';
import { CmsLogoProperties } from '../Models/CmsLoginHeaderProperties';
import { CMSComponent } from '../cms/cms.component';
import { Route, Router } from '@angular/router';
import { Canvg } from 'canvg';

import * as $ from 'jquery';

@Component({
  selector: 'app-cms-logo',
  templateUrl: './cms-logo.component.html',
  styleUrls: ['./cms-logo.component.css']
})
@NgModule({ imports: [FormsModule] })

export class CmsLogoComponent {
  header: {};
  constructor(private userService: CMSService, private http: HttpClient, private router: Router, private beneficiaryService: BeneficiaryService) { };
  cmsLogoObj = new CmsLogoProperties();

 // cmsComopnentObj = new CMSComponent(this.userService, this.http, this.router, this.beneficiaryService);
 ValidateFileFormat: boolean;
  public progress: number;
  public imagePath: any;
  public imageSPath: any;
  public message: string;
  public logoPath: string;
  ssvgurl: string;
  UpdateFileImage: string = "";
  createFileImage: any;
  uploadedstatus: boolean = false;

  // public uploadFile = (files) => {
  //   if (files.length === 0) {
  //     return;
  //   }
  //   let fileToUpload = <File>files[0]; 
  //   const formData = new FormData();
  //   formData.append('file', fileToUpload, fileToUpload.name);
  //   this.http.post('https://localhost:44339/api/CmsLogin/SaveHeaderLogo', formData, { reportProgress: true, observe: 'events' })
  //     .subscribe(event => {
  //       if (event.type === HttpEventType.UploadProgress)
  //         this.progress = Math.round(100 * event.loaded / event.total);
  //       else if (event.type === HttpEventType.Response) {
  //         this.imagePath = event.body.toString();
  //         this.message = 'Uploaded to Database...';
          
  //       }
  //     });
  // }
  ngOnInit() {
    this.LoadEditableData();
  }
  LoadEditableData() {
    try {
      if (localStorage.getItem("serialNo") != undefined || localStorage.getItem("serialNo") != null) {
        let sr = Number(localStorage.getItem("serialNo"));
        document.querySelector(".updatemain").classList.remove('update_section');
        if (sr != 0 || sr != undefined) {
          this.userService.getLogoById(sr).subscribe((data) => {
            this.cmsLogoObj = data[0] as CmsLogoProperties;
            this.ssvgurl = this.cmsLogoObj.logo ;
           
            localStorage.removeItem("serialNo");
          });
        }
        else {
          document.querySelector(".createmain").classList.remove('create_section');
        }
      }
      else {
        document.querySelector(".createmain").classList.remove('create_section');
      }
    }
    catch (e) {
      ////////////console.log (e);
    }
  }

  createlogo(){
    var formData = new FormData();
    formData.append("logo", this.createFileImage);
    formData.append(this.UpdateFileImage, this.cmsLogoObj.logo)
    this.userService.createLogo(formData).subscribe((data) => {
      if (data == true) {
        this.router.navigateByUrl('/cms');
       
      }
      else {

        $("#response-screen").show();
        document.getElementById("response-screen").innerHTML = "Error occured while inserting data :("
        $("#response-screen").delay(5000).hide(1000);
      }
      });
}

 

  onSubmit() {
    if (this.cmsLogoObj.logo.length === 0) {
      return;
    }
    this.createlogo();
   
  }
  cancel() {
    this.router.navigateByUrl('/cms');
  }
  validateFileType(fileName): boolean {

    var idxDot = fileName.lastIndexOf(".") + 1;
    var extFile = fileName.substr(idxDot, fileName.length).toLowerCase();
    if (extFile == "svg" || extFile == "png" || extFile == "jpg" || extFile == "jpeg") {
      //TO DO
      this.ValidateFileFormat = true;
    } else {
      this.ValidateFileFormat = false;
    }
    return this.ValidateFileFormat;
  }

  onFileChangedCreate(event) {
    this.ssvgurl = "";
    const filess = event.target.files;

    this.createFileImage = event.target.files[0].name;
    this.cmsLogoObj.logo  = event.target.files[0];
    if (filess.length === 0) {
      return;
    }
    const filename = event.target.files[0].name;
    const mimeType = filess[0].type;
    if (mimeType.match(/image\/*/) == null) {
      this.message = "Only images are supported.";
      return;
    }

    if (this.validateFileType(filename) == true) {
      var idxDot = filename.lastIndexOf(".") + 1;
      var extFile = filename.substr(idxDot, filename.length).toLowerCase();
      if (extFile == "svg") {
        const reader = new FileReader();
        this.imagePath = filess;
        reader.readAsDataURL(filess[0]);
        let imageurl = document.getElementById("svg") as HTMLImageElement;
       
        reader.onload = async (_event) => {

          imageurl.src = (reader.result).toString();
          const canvass = document.createElement('canvas');
          canvass.id = "newcanvas";
          canvass.width = 250;
          canvass.height = 250;
          const ctx = canvass.getContext('2d');
          const v = await Canvg.from(ctx, imageurl.src);

          v.start();
          var processedimage = canvass.toDataURL("img/png");
          this.ssvgurl = "";
          this.ssvgurl = processedimage;




        }

      }
      else {


        const reader = new FileReader();
        this.imagePath = filess;
        reader.readAsDataURL(filess[0]);
        reader.onload = (_event) => {
          this.ssvgurl = (reader.result).toString();

        }
      }


    }
    else {

      document.getElementById("messageLogo1").innerHTML = "Only .svg & .png Formats Are Allowed";
      this.ssvgurl = "";
      setTimeout(() => { document.getElementById("messageLogo1").innerHTML = ""; }, 5000);
      return;
    }
  }
  onFileclick(event) {
    this.ssvgurl = "";
    const files = event.target.files;
    this.UpdateFileImage = event.target.files[0].name;
    this.cmsLogoObj.logo= event.target.files[0];
    if (files.length === 0) {
      return;
    }
    const filename = event.target.files[0].name;
    const mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      this.message = "Only images are supported.";
      return;
    }

    if (this.validateFileType(filename) == true) {
      var idxDot = filename.lastIndexOf(".") + 1;
      var extFile = filename.substr(idxDot, filename.length).toLowerCase();
      if (extFile == "svg") {
        const reader = new FileReader();
        this.imagePath = files;
        reader.readAsDataURL(files[0]);
        let imageurl = document.getElementById("svg") as HTMLImageElement;
        imageurl.style.display = "none";
        reader.onload = async (_event) => {

          imageurl.src = (reader.result).toString();
          const canvass = document.createElement('canvas');
          canvass.id = "newcanvas";
          canvass.width = 250;
          canvass.height = 250;
          const ctx = canvass.getContext('2d');
          /* ctx.clearRect(0, 0, canvass.width, canvass.height);*/
          const v = await Canvg.from(ctx, imageurl.src);

          v.start();
          var processedimage = canvass.toDataURL("img/png");
          //var s = new XMLSerializer().serializeToString(imageurl.src);
          //var encodedData = window.btoa(s);
          //this.ssvgurl = encodedData;
          this.ssvgurl = "";
          this.ssvgurl = processedimage;




        }

      }
      else {

        this.ssvgurl = "";
        const reader = new FileReader();
        this.imagePath = files;
        reader.readAsDataURL(files[0]);
        reader.onload = (_event) => {
          this.ssvgurl = (reader.result).toString();

        }
      }


    }
    else {

      document.getElementById("messageLogo1").innerHTML = "Only .svg & .png Formats Are Allowed";
      this.ssvgurl = "";
      setTimeout(() => { document.getElementById("messageLogo1").innerHTML = ""; }, 5000);
      return;
    }
   
  }
    
  UpdateData() {
  
    this.UpdateLogo();
  }
  UpdateLogo() {
    var formData = new FormData();
    formData.append("sr", (this.cmsLogoObj.sr).toString());
    formData.append("logo", this.UpdateFileImage);
    formData.append(this.UpdateFileImage, this.cmsLogoObj.logo)
    this.userService.updateLogo(formData).subscribe((data) => {
      if (data == true) {
        this.router.navigateByUrl('/cms');

      }
      else {

        $("#response-screen").show();
        document.getElementById("response-screen").innerHTML = "Error occured while inserting data :("
        $("#response-screen").delay(5000).hide(1000);
      }
    });
  }

}
